export default "__VITE_ASSET__CHYRVcRL__"